import { Inline, Text } from '@front10/base-elements';
import dayjs from 'dayjs';
import React from 'react';
import { useFullMonths } from '../i18n';

type MonthCaptionProps = {
  date: Date;
  style?: React.CSSProperties;
  showYear?: boolean;
  monthSettings?: $TSFixMe;
  yearSettings?: $TSFixMe;
};

function MonthCaption(props: MonthCaptionProps) {
  const { date, showYear } = props;
  const monthsLabels = useFullMonths();

  return (
    <Inline {...props} className="front10-date-selector-caption" py={3} gap={1}>
      <Text className="front10-date-selector-caption-month" {...props.monthSettings} as="span">
        {monthsLabels[date.getMonth()]}
      </Text>
      {showYear && (
        <Text className="front10-date-selector-caption-year" {...props.yearSettings} as="span">
          {dayjs(date).format('YYYY')}
        </Text>
      )}
    </Inline>
  );
}

export default MonthCaption;
